module.exports = __webpack_public_path__ + "static/img/GettyImages-588367166_a.6b68efb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/GettyImages-588367166_a.jpg
// module id = /e9f
// module chunks = 0